import React from "react";
import { WorkflowTroubleshoot } from "us.collection/components";

const Cnt_Troubleshoot: React.FC = () => {
  return <WorkflowTroubleshoot />;
};

export default Cnt_Troubleshoot;
